import { CaretSortIcon, CheckIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import { containers } from "src/lib/db";
import { cn } from "src/lib/utils";
import { Button } from "../ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
} from "../ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { useDispatch } from "react-redux";
import { selectContainer } from "src/lib/slices/drinkSelectionSlice";

export default function ContainerSearch({ open, setOpen }) {
  const dispatch = useDispatch();

  const [searchOpen, setSearchOpen] = useState(false);
  const [searchValue, setSearchValue] = useState(null);

  useEffect(() => {
    if (searchValue === null) return;
    dispatch(selectContainer(searchValue));
    setOpen(false);
    setSearchValue(null);
  }, [dispatch, searchValue, setOpen]);

  return (
    <Popover open={searchOpen} onOpenChange={setSearchOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={searchOpen}
          className="justify-between"
        >
          {searchValue
            ? containers.find((container) => container.id === searchValue)?.name
            : "Vyhledat nádobu..."}
          <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent>
        <Command>
          <CommandInput placeholder="Vyhledat nádobu..." className="h-9" />
          <CommandEmpty>Žádné nádoby nenalezeny.</CommandEmpty>
          <CommandGroup>
            {containers.map((container) => (
              <CommandItem
                key={container.id}
                value={container.name}
                onSelect={(currentValue) => {
                  const container = containers.find(
                    (container) => container.name.toLowerCase() === currentValue
                  );
                  setSearchValue(
                    container.id === searchValue ? null : container.id
                  );
                  setSearchOpen(false);
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "1.25rem",
                  }}
                >
                  <img
                    src={`/container-images/${container.icon}`}
                    alt=""
                    style={{
                      height: "1.25rem",
                      paddingRight: "1ch",
                    }}
                  />
                </div>
                <div>
                  {container.name}{" "}
                  <span style={{ fontSize: "0.75rem" }}>
                    ({container.volume} {container.units})
                  </span>
                </div>
                <CheckIcon
                  className={cn(
                    "ml-auto h-4 w-4",
                    searchValue === container.id ? "opacity-100" : "opacity-0"
                  )}
                />
              </CommandItem>
            ))}
          </CommandGroup>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
